import React from 'react';

import format from 'date-fns/format';
import { connect } from 'react-redux';

import { InputDate } from '@nerdwallet/currency';

import { AMORTIZATION } from '../../../lib/analytics-constants';
import { validationsSelector } from '../../../lib/selectors';
import {
  manualInputsSelector,
  inputsSelector,
} from '../../../lib/selectors/amortization-calculator-selector';
import { AmortizationInput, inputOnChange } from '../../../lib/utils';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const LoanStartDate: React.FC<AmortizationInput> = ({
  inputs,
  dispatch,
  analytics,
  validations,
  label = '',
  className = '',
  fullWidth,
  manualInputs,
}) => {
  const placeholder =
    inputs?.loanStartDate || format(new Date(), 'MM / dd / yyyy');
  const value = manualInputs?.loanStartDate;
  const errorMessage = validations?.loanStartDate?.[0];
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_ts',
        mapValue: (target: string) => {
          const timestamp = Date.parse(target);
          // return user input that was invalid
          return Number.isNaN(timestamp) ? target : timestamp;
        },
      };
    }

    inputOnChange({
      event: e,
      dispatch,
      bedrock,
      fieldName: 'loanStartDate',
      calculator: AMORTIZATION,
    });
  };

  return (
    <InputDate
      label={label}
      placeholder={placeholder}
      value={value}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

const mapStateToProps = (state) => ({
  manualInputs: manualInputsSelector(state),
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(LoanStartDate);
